module.exports = "/**\n * The markdown on the left doesn't look pretty yet\n *\n * Let's beautify!\n */\n\n#work-text {\n  max-height: 90%;\n}\n\n#style-text {\n  font-size: 16px;\n}\n\n#work-text.flipped {\n  -webkit-transform: rotateX(0deg) rotateY(190deg) rotateZ(180deg);\n}\n\n#work-text .md {\n  -webkit-transform: rotateY(190deg) rotateZ(180deg);\n  margin-top: 1200px;\n}\n\n/**\n * Now drum rolls：\n *\n * 3\n * 2\n * 1\n *\n *\n * Haha...Nothing really.\n *\n * Well, actually here comes!\n *\n */\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/style-text/styles1.css
// module id = UXP2
// module chunks = 1